import { useCallback, useEffect, useState } from "react";
import {
  getPropertiesByOwner, getPropertiesSharedWithEmail,
} from "../helpers/firestoreService";
import { useAuthUser } from "./AuthProvider";

/**
 * Every property the signed-in manager owns or has been given access to.
 * Shared by the portfolio-wide Applications / Payments / Inspections / Chats
 * pages so they all show the same set of properties.
 */
export default function useMyProperties() {
  const user = useAuthUser();
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!user?.uid) return;
    setLoading(true);
    try {
      const [mine, shared] = await Promise.all([
        getPropertiesByOwner(user.uid),
        user.email ? getPropertiesSharedWithEmail(user.email).catch(() => []) : [],
      ]);
      const byId = new Map();
      [...mine, ...shared].forEach((p) => byId.set(p.id, p));
      setProperties([...byId.values()]);
    } catch (e) {
      console.error("Load properties error:", e);
    } finally {
      setLoading(false);
    }
  }, [user?.uid, user?.email]);

  useEffect(() => { load(); }, [load]);

  return { user, properties, loading, reload: load };
}
